// libraries.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsHubSpot } from '@store/apiSlices/apiSlices';

// interfaces.
import {
  ListDocumentsParams,
  ListDocumentsResponseCO,
  ListDocumentsResponseMX,
} from '@domains/documents-review/interfaces/interfaces';
import {
  DocumentsMX,
  mapDocumentsMX,
} from '@domains/documents-review/helpers/mapDocumentsMX';
import {
  DocumentsCO,
  mapDocumentsCO,
} from '@domains/documents-review/helpers/mapDocumentsCO';

export type ListDocumentsResponse =
  | ListDocumentsResponseCO
  | ListDocumentsResponseMX;

export const listDocuments = apiDocumentsHubSpot.injectEndpoints({
  endpoints: builder => ({
    getListDocuments: builder.query({
      query: ({ country, nid }: ListDocumentsParams) => {
        return `/get_document?country=${country}&nid=${nid}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getListDocuments',
        };
        return modelError;
      },
      transformResponse: (
        response: ListDocumentsResponse,
        _,
        args: ListDocumentsParams
      ) => {
        if (args.country === 'MX') {
          return mapDocumentsMX(response as DocumentsMX);
        } else if (args.country === 'CO') {
          return mapDocumentsCO(response as DocumentsCO);
        }
        return [];
      },
    }),
  }),
});

export const { useGetListDocumentsQuery } = listDocuments;
